import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
let _cache = null;

export async function fetchSettings(force = false) {
  if (_cache && !force) return _cache;
  const { data } = await axios.get(`${BACKEND}/api/settings`);
  _cache = data;
  return data;
}

export function logoSrc(settings) {
  return settings?.logo_url ? `${BACKEND}${settings.logo_url}` : "/renka-logo.png";
}

export function clearSettingsCache() {
  _cache = null;
  if (typeof window !== "undefined") window.dispatchEvent(new Event("renka-settings-updated"));
}
